module.exports = __webpack_public_path__ + "img/corp-benefits-engagement.4bc677ab.svg";